import React from 'react';
import styled from 'styled-components';

const SupportContainer = styled.div`
  background-color: #f8f9fa;
  border-left: 5px solid var(--secondary);
  padding: 1.5rem;
  margin-top: 3rem;
  border-radius: 8px;
  font-size: 0.95rem;
  color: var(--gray);
  line-height: 1.6;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.04);
`;

const SupportTitle = styled.h4`
  color: var(--secondary-dark);
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  
  i {
    margin-right: 0.5rem;
    font-size: 1.3rem;
  }
`;

const SupportText = styled.p`
  margin-bottom: 1rem;
`;

const ResourceList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 1rem;
  
  li {
    margin-bottom: 0.75rem;
    padding-left: 1.5rem;
    position: relative;
    
    i {
      position: absolute;
      left: 0;
      top: 0.25rem;
      color: var(--secondary);
    }
  }
  
  a {
    color: var(--secondary-dark);
    font-weight: 500;
    text-decoration: none;
    transition: all 0.2s ease;
    
    &:hover {
      color: var(--secondary);
      text-decoration: underline;
    }
  }
`;

const ParentSupportBox = () => {
  return (
    <SupportContainer>
      <SupportTitle>
        <i className="bi bi-heart-pulse"></i>
        Parent Mental Health Support
      </SupportTitle>
      <SupportText>
        Sleep challenges can be stressful for the whole family. If you're feeling overwhelmed, anxious, or struggling with your mental health, please remember that you're not alone and support is available.
      </SupportText>
      <ResourceList>
        <li>
          <i className="bi bi-link-45deg"></i>
          <a href="https://www.ruok.org.au/" target="_blank" rel="noopener noreferrer">
            R U OK? - Resources for supporting mental health
          </a>
        </li>
        <li>
          <i className="bi bi-link-45deg"></i>
          <a href="https://www.beyondblue.org.au/" target="_blank" rel="noopener noreferrer">
            Beyond Blue - 1300 22 4636 - Support for anxiety and depression
          </a>
        </li>
        <li>
          <i className="bi bi-link-45deg"></i>
          <a href="https://www.gidgetfoundation.org.au/" target="_blank" rel="noopener noreferrer">
            Gidget Foundation - Support for perinatal anxiety and depression
          </a>
        </li>
        <li>
          <i className="bi bi-link-45deg"></i>
          <a href="https://www.panda.org.au/" target="_blank" rel="noopener noreferrer">
            PANDA - 1300 726 306 - National helpline for perinatal mental health
          </a>
        </li>
        <li>
          <i className="bi bi-link-45deg"></i>
          <a href="https://www.lifeline.org.au/" target="_blank" rel="noopener noreferrer">
            Lifeline - 13 11 14 - 24/7 crisis support
          </a>
        </li>
      </ResourceList>
      <SupportText>
        Remember, seeking help is a sign of strength, not weakness. Your mental health matters, and it's important for both you and your child.
      </SupportText>
    </SupportContainer>
  );
};

export default ParentSupportBox;
